<template>
    <div class="wrapper ticket-list-container">
        <div class="row">
            <div class="col-md-3">
                <section class="content-box no-padding">
                    <header>
                        <h3>{{ lang.tickets['left-menu'].title }}</h3>
                    </header>
                    <ul class="left-menu">
                        <li v-if="false">
                            <label for="start_pos">{{ lang.tickets.start_position }}</label>
                            <select v-model="position" class="form-control">
                                <option
                                    v-for="pos in startPositions"
                                    :key="'pos-' + pos.id"
                                    :value="pos.id"
                                >{{ pos.name }}</option>
                            </select>
                        </li>
                        <li>
                            <label for="trip-datepicker">{{ lang.main.date }}</label>
                            <small v-if="dateMsg" v-html="dateMsg"></small>
                            <input type="text" id="trip-datepicker" class="form-control">
                        </li>
                    </ul>
                </section>

                <section class="content-box no-padding">
                    <header>
                        <h3>{{ lang.vouchers.giftcards.title }}</h3>
                    </header>
                    <ul class="left-menu">
                        <li>
                            <a href="/giftcards">
                                <span class="glyphicon glyphicon-gift" aria-hidden="true"></span>
                                {{ lang.tickets['left-menu'].giftcard }}
                            </a>
                        </li>
                    </ul>
                </section>
            </div>

            <div class="col-md-9">
                <div class="ticket-list">
                    <h2
                        v-if="trips.length === 0"
                        class="text-center"
                        style="margin-bottom:400px;"
                        v-html="lang.tickets.list.empty"
                    ></h2>
                    <div class="ticket-notice" v-if="trips.length > 0">
                        <div class="ticket-notice__title">{{ lang.tickets.list.tours_on }} {{ selectedDay }}</div>
                        <div class="ticket-notice__subtitle">{{ lang.tickets.list.only_available_tickets }}.</div>
                    </div>
                    <TripTicketPurchase
                        v-for="trip in trips"
                        :key="trip.id"
                        :trip="trip"
                        :lang="lang"
                        @addToCart="addToCart"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TripTicketPurchase from '@elems/TripTicketPurchase'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import {language as flatpickrLanguage } from "@elems/flatpickr-language"

export default {
    components: {
        TripTicketPurchase
    },

    props: {
        firstDateWithTrip: Number,
        b2b: { type: Boolean, default: false },
        lang: Object,
    },

    data() {
        return {
            amount: 1,
            position: 1,
            picker: null,
            trips: [],
            availableDates: {},
            dateMsg: '',
        }
    },

    computed: {
        startPositions() {
            return [
                { id: 1, name: this.lang.tickets.start_pos[1] },
                { id: 2, name: this.lang.tickets.start_pos[2] },
            ]
        },

        selectedDay() {
            return !this.picker && this.picker.selectedDates.length === 0
                ? moment().format('DD/MM/YYYY')
                : moment(this.picker.selectedDates[0]).format('DD/MM/YYYY')
        },
    },

    watch: {
        position(_newVal, _oldVal) {
            this.loadTickets()
        }
    },

    mounted() {
        this.picker = flatpickr('#trip-datepicker', {
            defaultDate: this.firstDateWithTrip ? new Date(this.firstDateWithTrip * 1000) : new Date(),
            dateFormat: 'd/m/Y',
            locale: flatpickrLanguage,
            weekNumbers: true,
            minDate: new Date(),
            maxDate: moment().add(app.settings.trip_open_time, 'days').toDate(),
            onChange: (date) => {
                this.loadTickets(moment(date[0]).format('YYYY-MM-DD'))
            },
            onDayCreate: (_date, _dateStr, _settings, dayElem) => {
                dayElem.setAttribute('data-date', moment(dayElem.dateObj).format('YYYY-MM-DD'))
            },
            onReady: () => {
                this.loadAvailableDates()
            },
            onMonthChange: () => {
                this.loadAvailableDates()
            },
            onYearChange: () => {
                this.loadAvailableDates()
            },
            onClose: () => {
                this.dateMsg = ''
            },
        })

        this.loadAvailableDates()
        this.loadTickets()
    },

    methods: {
        getDisplayedMonth() {
            if (this.picker === null) {
                return '';
            }
            return this.picker.currentYear + '-' + (this.picker.currentMonth + 1)
        },

        loadTickets(date) {
            if (!date) {
                date = moment(this.picker.selectedDates[0]).format('YYYY-MM-DD')
            }
            axios.get('/trips/' + date, {params: {start_pos: this.position}})
                .then(({data}) => {
                    this.trips = data
                    this.updateCalenderColors()
                })
                .catch((error) => console.error(error))
        },

        loadAvailableDates() {
            if (this.getDisplayedMonth() === '') {
                return
            }

            this.dateMsg = 'Indlæser dage...'
            $.ajax({
                async: false,
                method: 'GET',
                url: '/trips/dates/' + this.getDisplayedMonth(),
                success: (dates) => {
                    this.availableDates = dates
                    this.updateCalenderColors()
                }
            })
            setTimeout(() => {
                this.dateMsg = ''
            }, 500)
        },

        updateCalenderColors() {
            for (let dateKey in this.availableDates) {
                const selectorScope = '.flatpickr-day[data-date="' + dateKey + '"]'

                if (!$(selectorScope).length) {
                    continue
                }

                // Dark green / light green
                $(selectorScope).css({
                    'background': '#60aa00',
                    'color': '#FFFFFF',
                })
            }
        },

        addToCart({ amount, tripId, resolve, reject }) {
            axios.post('/cart/ticket', { amount, tripId })
                .then(({ data }) => {
                    $('#count_2').text(data.cartTotalItems)
                    const response = {
                        success: data.tickets.length > 0,
                        available: data.ticketsAvailable,
                        msg: ''
                    }
                    if (response.success) {
                        response.msg = this.lang.tickets.tickets_added_to_cart
                    }
                    resolve(response)
                })
                .catch((error) => {
                    reject('Session expired')
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.ticket-notice {
    margin-bottom: 15px;
    &__title {
        font-size: 3rem;
        font-weight: 500;
    }

    &__subtitle {
        font-size: 1.6rem;
    }
}

.ticket-list-container {
    min-height: 550px;
}
</style>
